export const publication = () => {
        const loader = document.getElementById('loader');
        const cache = {};
        let controllers = {};

        const selectPapersLines = document.getElementById('lineas-papers');
        const selectPapersTypes = document.getElementById('types-papers');
        const selectCongressLines = document.getElementById('lineas-congress');
        const selectCongressTypes = document.getElementById('types-congress');

        const sectionPapers = document.getElementById('publication-papers-list');
        const sectionCongress = document.getElementById('publication-congress-list');

        const paginationPapers = document.getElementById('paginationpapers');
        const paginationCongress = document.getElementById('paginationcongress');

        function showLoader() {
            loader.style.opacity = 1;
            loader.style.display = 'block';
        }

        function hideLoader() {
            loader.style.opacity = 0;
            loader.style.display = 'none';
        }

        function updateHeaderHeight() {

          const header = document.querySelector('.header');

          const headerHeight = header.offsetHeight;

          document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        }

        function initHeaderHeight() {
          updateHeaderHeight();

          window.addEventListener('resize', updateHeaderHeight);
        }

        function generateCacheKey(titularity, line_id, type, page) {
            return `${titularity}-${line_id}-${type}-${page}`;
        }

        function fetchPublications(titularity, line_id, type, page, section) {
            const cacheKey = generateCacheKey(titularity, line_id, type, page);

            if (cache[cacheKey]) {
                // Utilizar el cache
                document.querySelector(`#publications${titularity}`).innerHTML = cache[cacheKey].publications;
                document.querySelector(`#pagination${titularity}`).innerHTML = cache[cacheKey].pagination;
                section.scrollIntoView();
                return;
            }

            // Cancelar la solicitud anterior si existe
            if (controllers[titularity]) {
                controllers[titularity].abort();
            }

            const publicationPapersListElement = document.getElementById('publication-papers-list');
            const dataPapersUrl = publicationPapersListElement.dataset['url'];
            if (dataPapersUrl === undefined || !dataPapersUrl)
                return;

            const publicationCongressListElement = document.getElementById('publication-congress-list');
            const dataCongressUrl = publicationCongressListElement.dataset['url'];
            if (dataCongressUrl === undefined || !dataCongressUrl)
                return;


            // Crear un nuevo controlador para la solicitud actual
            controllers[titularity] = new AbortController();
            const signal = controllers[titularity].signal;

            showLoader();
            fetch(`${dataPapersUrl}/${titularity}?line_id=${line_id}&type=${type}&page=${page}`, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                signal: signal
            })


            fetch(`${dataCongressUrl}/${titularity}?line_id=${line_id}&type=${type}&page=${page}`, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                signal: signal
            })
                .then(response => response.json())
                .then(data => {
                    document.querySelector(`#publications${titularity}`).innerHTML = data.publications;
                    document.querySelector(`#pagination${titularity}`).innerHTML = data.pagination;
                    cache[cacheKey] = data; // Almacenar en el cache
                    hideLoader();
                    section.scrollIntoView();
                })
                .catch(error => {
                    if (error.name === 'AbortError') {
                        console.log('Solicitud abortada');
                    } else {
                        console.error('Error:', error);
                    }
                    hideLoader();
                });
        }

        function handlePagination(event) {
            const target = event.target.closest('a');
            if (target) {
                event.preventDefault();
                const page = event.target.href.split('page=')[1];

                if (event.currentTarget.id === 'paginationpapers') {
                    if(selectPapersTypes !== null){
                        fetchPublications('papers', selectPapersLines.value, selectPapersTypes.value, page, sectionPapers);
                    }else{
                        fetchPublications('papers', selectPapersLines.value, 'all', page, sectionPapers);
                    }
                    
                } else if (event.currentTarget.id === 'paginationcongress') {
                    if(selectCongressTypes !== null){
                        fetchPublications('congress', selectCongressLines.value, selectCongressTypes.value, page, sectionCongress);
                    }else{
                        fetchPublications('congress', selectCongressLines.value, 'all', page, sectionCongress);
                    }
                }
            }
        }

        if(selectPapersTypes != null){
            selectPapersLines.addEventListener('change', function() {
                fetchPublications('papers', this.value, selectPapersTypes.value,1, sectionPapers);
            });

            selectPapersTypes.addEventListener('change', function() {
                fetchPublications('papers', selectPapersLines.value, this.value,1, sectionPapers);
            });
        }else{
            selectPapersLines.addEventListener('change', function() {
                fetchPublications('papers', this.value, 'all',1, sectionPapers);
            });
        }



        if(selectCongressTypes != null){
            selectCongressLines.addEventListener('change', function() {
                fetchPublications('congress', this.value, selectCongressTypes.value, 1,sectionCongress);
            });

            selectCongressTypes.addEventListener('change', function() {
                fetchPublications('congress', selectCongressLines.value, this.value, 1,sectionCongress);
            });
        }else{
            selectCongressLines.addEventListener('change', function() {
                fetchPublications('congress', this.value, 'all', 1,sectionCongress);
            });
        }




        paginationPapers.addEventListener('click', handlePagination);
        paginationCongress.addEventListener('click', handlePagination);

        initHeaderHeight();

        // No es necesario inicializar las publicationes aquí porque ya se cargan en el blade
};
publication();
